/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const ConnectionLink = core.serialization.object({
    token: core.serialization.string(),
});
